export default {
  main: "oklch(20% 0.030 250)",
  code: "oklch(50% 0.165 265 / 0.30)",
  section: "oklch(15% 0.02 255)",
  gradient: "radial-gradient(circle 2000px, oklch(60% 0.200 255 / 0.06) 0%, oklch(0% 0 0) 100%)",
  fade: {
    start: "oklch(0% 0 0)",
    end: "oklch(0% 0 0)"
  },
  electron: {
    vertical: "oklch(75% 0.125 250 / 0.55)",
    glow: "oklch(65% 0.200 255 / 0.22)"
  },
  term: {
    text: "oklch(70% 0.14 255)",
    background: "oklch(65% 0.1 255 / 0.1)"
  },
  rate: {
    ring: "oklch(44.95% 0 0)",
    sector: "oklch(100% 0 0 / 0.08)"
  },
  text: {
    weak: "oklch(40.50% 0.035 255)",
    medium: "oklch(100% 0 0 / 0.75)",
    strong: "oklch(100% 0 0)",
    error: "oklch(60% 0.2 25)"
  },
  border: {
    weak: "oklch(40% 0.035 255 / 0.2)",
    medium: "oklch(40% 0.035 255 / 0.3)",
    strong: "oklch(40% 0.035 255 / 0.5)"
  },
  button: {
    color: "oklch(60% 0.2 255)",
    shadow: "0 0 0 5px oklch(0% 0 0 / 0.4)",
    hover: "oklch(0 0 0 / 0.20)"
  },
  tooltip: {
    background: "oklch(0% 0 0)",
    shadow: "0 0 0 5px oklch(0% 0 0 / 0.4)"
  },
  underscore: {
    default: "oklch(100% 0 0 / 0.15)",
    hover: "oklch(100% 0 0)"
  },
  scroll: {
    thumb: "oklch(100% 0 0)",
    background: "transparent"
  },
  link: {
    text: "oklch(67% 0.168 255)",
    underscore: "oklch(100% 0 0 / 0.15)",
    hover: "oklch(40% 0.035 255 / 0.15)"
  },
  modal: {
    content: "oklch(17% 0.015 250)",
    backdrop: "oklch(0% 0 0 / 0.35)",
    shadow: "0 24px 80px oklch(0% 0 0 / 0.35)"
  },
  loader: {
    backdrop: "oklch(0% 0 0 / 0.35)",
    track: "oklch(30% 0.02 265)",
    spinner: "oklch(60% 0.2 255)"
  },
  error: {
    background: "oklch(63% 0.25 30 / 0.1)"
  }
};
